import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import ReportDashboardsConstructor from "./ReportDashboardsConstructor";
import reportConstructorService from "./Sevices/reportConstructorSevice";
import ReportConstructorPatternDashboard from "./ReportConstructorPatternDashboard";
import ReportConstructorPatternField from "./ReportConstructorPatternField";
import ReportFieldsConstructor from "./ReportFieldsConstructor";
import ReportConstructorVeicleReportCheck from "./ReportConstructorVeicleReportCheck";
import ReportConstructorDownloadExcelExample from "./ReportConstructorDownloadExcelExample";
import ReportChartFieldsConstructor from "./ReportChartFieldsConstructor";
import ReportChartExample from "./ReportChartExample";
import { v4 as uuidv4 } from "uuid";
import ReportConstructorChartCheck from "./ReportConstructorChartCheck";

class ReportConstructorChartToolPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      patternReport: null,
      customReport: null,
    };
  }

  componentDidMount() {
    const { selectedCustomReportId, reportsListData } = this.props;

    if (selectedCustomReportId !== null) {
      const customReport = reportsListData.filter((x) => {
        return x.id === selectedCustomReportId;
      })[0];

      if (customReport !== undefined) {
        const patternReport = reportsListData.filter((x) => {
          return (
            x.patternReport !== undefined &&
            x.patternReport !== null &&
            x.patternReport.customization &&
            x.buildType == customReport.buildType
          );
        })[0];

        this.setState({ patternReport, customReport });
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedCustomReportId, reportsListData } = this.props;

    if (selectedCustomReportId !== null && selectedCustomReportId !== prevProps.selectedCustomReportId) {
      const customReport = reportsListData.filter((x) => {
        return x.id === selectedCustomReportId;
      })[0];

      if (customReport !== undefined) {
        const patternReport = reportsListData.filter((x) => {
          return (
            x.patternReport !== undefined &&
            x.patternReport !== null &&
            x.patternReport.customization &&
            x.buildType == customReport.buildType
          );
        })[0];

        this.setState({ patternReport, customReport });
      }
    }

    const { customReport } = this.state;

    if (customReport !== null && selectedCustomReportId === null) {
      this.setState({ patternReport: null, customReport: null });
    }
  }

  render() {
    const { patternReport, customReport } = this.state;

    if (customReport === null) {
      return null;
    }

    customReport.countFixFields = patternReport.patternReport.fixFieldCount;

    return (
      <div className={styles.reportConstructorToolPanelContainer}>
        <div className={styles.reportConstructorTableContainer}>
          <ReportConstructorChartCheck customReport={customReport} />
          <div className={styles.reportConstructorPatternDataContainer}>
            <ReportConstructorPatternField fields={reportConstructorService.getPatternFields(patternReport, customReport)} />
          </div>

          <ReportChartFieldsConstructor fields={customReport.fields} />

          <ReportChartExample customReport={customReport} key={uuidv4()} />
        </div>
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportConstructorChartToolPanel)));
